import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/design-info.constant";

export {
    addDesignProducts,
    addSingleDesignProduct,
    updateSingleDesignProduct,
    getSingleDesignProduct,
    getAllDesignProducts,
    searchDesignProducts,
    searchDesignProductsWithSearchCriteria,
    prepareDesignProductsList
}

const collectionName = 'design-products';
const collectionReference = collection(fireStoreDB, collectionName);

const addDesignProducts = (designProducts) => {
    return Promise.map(designProducts, async designProduct => {
        await addSingleDesignProduct(designProduct);
    });
}

const addSingleDesignProduct = (designProduct) => {
    designProduct.createdAt = new Date();
    designProduct.updatedAt = designProduct.createdAt;
    return addDoc(collectionReference, designProduct);
}

const updateSingleDesignProduct = (designProduct) => {
    const documentReference = doc(fireStoreDB, collectionName, designProduct.id);
    designProduct.updatedAt = new Date();
    return setDoc(documentReference, designProduct);
}

const getSingleDesignProduct = async (designProductId) => {
    const documentReference = doc(fireStoreDB, collectionName, designProductId);
    const designProductDoc = await getDoc(documentReference);
    return prepareSingleDesignProduct(designProductDoc);
}

const getAllDesignProducts = async () => {
    let searchQuery = query(collectionReference);
    const designProductsResult = await getDocs(searchQuery);
    return prepareDesignProductsList(designProductsResult);
}

const searchDesignProducts = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const designProductResult = await getDocs(searchQuery);
    return prepareDesignProductsList(designProductResult);
}

const searchDesignProductsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchDesignProductsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const designProductResult = await getDocs(searchQuery);
    return prepareDesignProductsList(designProductResult);
}

const prepareDesignProductsList = (designProductResult) => {
    const designProductsList = [];

    _.forEach(designProductResult.docs, designProductDoc => {
        designProductsList.push(prepareSingleDesignProduct(designProductDoc));
    });

    return designProductsList;
}


const prepareSingleDesignProduct = (designProductDoc) => {
    const designProduct = designProductDoc.data();
    designProduct.id = designProductDoc.id;
    return designProduct;
}
